import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PluginType } from '../components/plugins/types';
import { agentStatusIdType } from '../model/types';
import { PluginError } from '../store/childStore/pluginStore';
import { getPluginStore } from '../utils/store/getStore';
import { getAgentCurrentPluginStatus, hasPluginTypeAnyErrors } from '../utils/store/pluginStore';

const { info } = Modal;

interface IAlertOnPluginErrorOptions {
    callPluginError: PluginError['CALL'];
    chatPluginError: PluginError['CHAT'];
    currentAgentStatusId: agentStatusIdType;
}

export default function useAlertOnPluginError({
    callPluginError,
    chatPluginError,
    currentAgentStatusId
}: IAlertOnPluginErrorOptions) {
    const { t } = useTranslation('common');

    const [canTriggerAlert, setCanTriggerAlert] = useState(false);
    const isAlertAvailable = useRef(true);

    useEffect(() => {
        if (currentAgentStatusId && isAlertAvailable?.current && currentAgentStatusId !== 6) {
            setCanTriggerAlert(true);
        }
    }, [currentAgentStatusId]);

    useEffect(() => {
        function showConfirm(pluginType: PluginType) {
            info({
                icon: <ExclamationCircleOutlined />,
                content: (
                    <div>
                        <p>{t('message.onAppError.title', { app: pluginType })}</p>
                        <p>{t('message.onAppError.content')}</p>
                    </div>
                ),
                onOk() {
                    changeAgentStatus();
                }
            });
        }

        const changeAgentStatus = async (statusId: agentStatusIdType = 6) => {
            await getPluginStore().changeAgentStatusOverMobXStore(statusId);
            // await mutate();
        };

        if (canTriggerAlert) {
            const currentAgentChatStatus = getAgentCurrentPluginStatus('chat');
            const currentAgentCallStatus = getAgentCurrentPluginStatus('call');

            let pluginType: PluginType;

            const isThereAnyCallPluginError = hasPluginTypeAnyErrors(PluginType.CALL, callPluginError);
            const isThereAnyChatPluginError = hasPluginTypeAnyErrors(PluginType.CHAT, chatPluginError);

            if (isThereAnyCallPluginError && currentAgentCallStatus && currentAgentCallStatus !== 'OFFLINE') {
                pluginType = PluginType.CALL;
            }

            if (
                isThereAnyChatPluginError &&
                !isThereAnyCallPluginError &&
                currentAgentChatStatus &&
                currentAgentChatStatus !== 'OFFLINE'
            ) {
                pluginType = PluginType.CHAT;
            }

            if (pluginType) {
                showConfirm(pluginType);
                isAlertAvailable.current = false;
            }
        }
    }, [callPluginError, chatPluginError, canTriggerAlert, t]);
}
